import type { MouseEvent } from 'react'
import { useNativeBridge } from '@dhl/native-bridge'
import { isNative } from '@dhl/webview'

export const useOpenExternalLink = () => {
  const { isInAppLinksSupported, openInAppBrowser } = useNativeBridge()

  return (href: string, event?: MouseEvent<HTMLAnchorElement | HTMLButtonElement>): void => {
    if (isNative() && isInAppLinksSupported()) {
      event?.preventDefault()
      openInAppBrowser({ url: href })
    } else {
      window.open(href, '_blank', 'noreferrer,noopener')
    }
  }
}
